
function changeToSlug(str) {
    try {
        if (!str) return "";
        if (str) {
            str = str.replace(/^\s+|\s+$/g, ""); // trim
            str = str.toLowerCase();

            //Đổi ký tự có dấu thành không dấu
            str = str.replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, "a");
            str = str.replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, "e");
            str = str.replace(/i|í|ì|ỉ|ĩ|ị/gi, "i");
            str = str.replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, "o");
            str = str.replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, "u");
            str = str.replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, "y");
            str = str.replace(/đ/gi, "d");

            str = str
                .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
                .replace(/\s+/g, "-") // collapse whitespace and replace by -
                .replace(/-+/g, "-"); // collapse dashes
        }
        return str;
    } catch (error) { }
}

const getSlugId = (slug) => {
    try {
        let arr = slug.split("-") || [];
        return arr.length ? arr.pop() : -1;
    } catch (error) { }
};

function getFileSlug(str) {
    try {
        if (str) {
            str = str.replace(/^\s+|\s+$/g, ""); // trim
            str = str.toLowerCase();

            //Đổi ký tự có dấu thành không dấu
            str = str.replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, "a");
            str = str.replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, "e");
            str = str.replace(/i|í|ì|ỉ|ĩ|ị/gi, "i");
            str = str.replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, "o");
            str = str.replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, "u");
            str = str.replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, "y");
            str = str.replace(/đ/gi, "d");

            str = str
                .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
                .replace(/\s+/g, "_") // collapse whitespace and replace by -
                .replace(/-+/g, "_"); // collapse dashes
        }
        return str;
    } catch (error) { }
}

const getSlugType = (slug) => {
    try {
        let arr = slug.split("-") || [];
        let objId = arr.length ? arr.pop() : -1;
        if (objId == -1) {
            throw new Error("Error Slug");
        } else {
            let typeSlug = objId.charAt(0);
            return {
                id: objId.replace(typeSlug, ""),
                typeSlug,
            };
        }
    } catch (error) {
        throw error;
    }
};

function getUuidFromSlug(slug) {
    try {
        if (!slug || typeof slug !== 'string') return '';
        const str = slug.trim();
        // Try find 'u' + UUID anywhere
        const uUuid = /u([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i.exec(str);
        if (uUuid && uUuid[1]) return uUuid[1];
        // Otherwise find any UUID substring
        const plain = /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i.exec(str);
        if (plain && plain[1]) return plain[1];
        return '';
    } catch (error) { return ''; }
}

/**
 * Strip HTML tags từ string
 * @param {string} html - String chứa HTML
 * @param {number} maxLength - Độ dài tối đa (tùy chọn)
 * @returns {string} - Text đã strip HTML
 */
function stripHTML(html, maxLength = null) {
    if (!html || typeof html !== 'string') return '';
    
    // Strip HTML tags
    let text = html
        .replace(/<[^>]*>/g, '') // Remove HTML tags
        .replace(/&nbsp;/g, ' ') // Replace &nbsp; with space
        .replace(/&amp;/g, '&') // Replace &amp; with &
        .replace(/&lt;/g, '<') // Replace &lt; with <
        .replace(/&gt;/g, '>') // Replace &gt; with >
        .replace(/&quot;/g, '"') // Replace &quot; with "
        .replace(/&#39;/g, "'") // Replace &#39; with '
        .replace(/\s+/g, ' ') // Normalize whitespace
        .trim();
    
    // Limit length if specified
    if (maxLength && text.length > maxLength) {
        text = text.substring(0, maxLength).trim();
        // Try to cut at word boundary
        const lastSpace = text.lastIndexOf(' ');
        if (lastSpace > maxLength * 0.8) {
            text = text.substring(0, lastSpace) + '...';
        } else {
            text = text + '...';
        }
    }
    
    return text;
}

export {
    changeToSlug,
    getSlugId,
    getSlugType,
    getFileSlug,
    getUuidFromSlug,
    stripHTML
};
